import { render, staticRenderFns } from "./DeleteEmailDialog.vue?vue&type=template&id=5bbcf773&scoped=true"
import script from "./DeleteEmailDialog.vue?vue&type=script&lang=js"
export * from "./DeleteEmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbcf773",
  null
  
)

export default component.exports